// src/components/CookieConsent/cookie-manager.js
import i18n from '@/Language';
const CookieManager = {
  COOKIE_CONSENT_KEY: 'cookie_consent',
  COOKIE_EXPIRY_DAYS: 365,

  // Cookie类别和子类别配置
  cookieCategories: {
    necessary: {
      name: i18n.t('cookie.necessary'),
      description: i18n.t('cookie.necessaryExplain'),
      required: true
    },
    performance: {
      name: i18n.t('cookie.performance'),
      description: i18n.t('cookie.performanceExplain'),
      required: false
    },
    functional: {
      name: i18n.t('cookie.functional'),
      description: i18n.t('cookie.functionalExplain'),
      required: false
    },
    targeting: {
      name: i18n.t('cookie.targeting'),
      description: i18n.t('cookie.targetingExplain'),
      required: false
    }
  },

  // Cookie子类别详情
  cookieDetails: {
    necessary: [
      {
        name: i18n.t('cookie.necessaryAccount'),
        cookieName: 'account',
        description: i18n.t('cookie.necessaryAccountExplain'),
        duration: i18n.t('cookie.longTerm'),
        required: true
      },
      {
        name: i18n.t('cookie.sessionManagement'),
        cookieName: 'JSESSIONID',
        description: i18n.t('cookie.sessionManagementExplain'),
        duration: i18n.t('cookie.longTerm'),
        required: true
      }
    ],
    performance: [
      {
        name: i18n.t('cookie.userInfo'),
        cookieName: '_arms_uid',
        description: i18n.t('cookie.userInfoExplain'),
        duration: i18n.t('cookie.duration180'),
      },
      {
        name: i18n.t('cookie.deviceInfo'),
        cookieName: 'os.type、 os.version、device.brand、device.type、os.container',
        description: i18n.t('cookie.deviceInfoExplain'),
        duration: i18n.t('cookie.durationSession'),
      },
      {
        name: i18n.t('cookie.pageInfo'),
        cookieName: 'view.name、resource.url',
        description: i18n.t('cookie.pageInfoExplain'),
        duration: i18n.t('cookie.durationSession'),
      },
      {
        name: i18n.t('cookie.networkInfo'),
        cookieName: 'net.ip、isp.name、net.model',
        description: i18n.t('cookie.networkInfoExplain'),
        duration: i18n.t('cookie.durationSession'),
      },
    ],
    functional: [
      // {
      //   name: '用户偏好',
      //   cookieName: 'remember',
      //   description: '记录用户登录偏好，提供使用便利（非核心功能），即使缺少该 Cookie，网站仍可正常运行（用户每次需手动输入密码）',
      //   duration: '长期有效',
      //   required: false
      // },
      {
        name: i18n.t('cookie.userPreference'),
        cookieName: 'sidebarStatus',
        description: i18n.t('cookie.userPreferenceExplain'),
        duration: i18n.t('cookie.durationSession'),
        required: false
      }
    ],
    targeting: [
      // 定向Cookie详情
    ]
  },

  // 获取当前同意状态
  getConsent() {
    const stored = localStorage.getItem(this.COOKIE_CONSENT_KEY);
    if (stored) {
      try {
        return JSON.parse(stored);
      } catch (e) {
        return null;
      }
    }
    return null;
  },

  // 保存同意状态
  saveConsent(consent) {
    const consentWithTimestamp = {
      ...consent,
      lastUpdated: new Date().toISOString()
    };
    localStorage.setItem(this.COOKIE_CONSENT_KEY, JSON.stringify(consentWithTimestamp));
    this.applyCookiePreferences(consent);
  },

  // 应用Cookie偏好
  applyCookiePreferences(consent) {
    // 必要Cookie始终启用
    this.setNecessaryCookies();
    
    if (consent.performance) {
      this.enablePerformanceCookies();
    } else {
      this.disablePerformanceCookies();
    }
    
    if (consent.functional) {
      this.enableFunctionalCookies();
    } else {
      this.disableFunctionalCookies();
    }
    
    if (consent.targeting) {
      this.enableTargetingCookies();
    } else {
      this.disableTargetingCookies();
    }
  },

  setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  },

  deleteCookie(name) {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  },

  setNecessaryCookies() {
    // 设置必要Cookie
    // this.setCookie('account', 'authenticated', this.COOKIE_EXPIRY_DAYS);
    // this.setCookie('JSESSIONID', 'session_id', this.COOKIE_EXPIRY_DAYS);
    this.setCookie('necessary_cookies_accepted', 'true', this.COOKIE_EXPIRY_DAYS);
  },

  enablePerformanceCookies() {
    this.setCookie('performance_cookies_accepted', 'true', this.COOKIE_EXPIRY_DAYS);
    this.loadPerformanceScripts();
  },

  disablePerformanceCookies() {
    this.deleteCookie('performance_cookies_accepted');
    this.removePerformanceScripts();
  },

  enableFunctionalCookies() {
    this.setCookie('functional_cookies_accepted', 'true', this.COOKIE_EXPIRY_DAYS);
    this.loadFunctionalScripts();
  },

  disableFunctionalCookies() {
    this.deleteCookie('functional_cookies_accepted');
    this.removeFunctionalScripts();
  },

  enableTargetingCookies() {
    this.setCookie('targeting_cookies_accepted', 'true', this.COOKIE_EXPIRY_DAYS);
    this.loadTargetingScripts();
  },

  disableTargetingCookies() {
    this.deleteCookie('targeting_cookies_accepted');
    this.removeTargetingScripts();
  },

  loadPerformanceScripts() {
    // 加载性能分析脚本
  },

  loadFunctionalScripts() {
    // 加载功能型脚本
  },

  loadTargetingScripts() {
    // 加载定向广告脚本
  },

  removePerformanceScripts() {},
  removeFunctionalScripts() {},
  removeTargetingScripts() {},

  shouldShowBanner() {
    const consent = this.getConsent();
    return !consent;
  }
};

export default CookieManager;
